import angular from 'angular';

import CookieNotificationComponent from './cookie-notification.cmpt';

export default angular.module('application.component.cookie-notification', [])
    .component(CookieNotificationComponent.selector, CookieNotificationComponent);



// WEBPACK FOOTER //
// ./src/application/component/cookie-notification/index.js